__turbopack_context__.v({
  "card": "jLYcwq_card",
  "cardImage": "jLYcwq_cardImage",
  "cardImageWrapper": "jLYcwq_cardImageWrapper",
  "cardSubtitle": "jLYcwq_cardSubtitle",
  "cardTitle": "jLYcwq_cardTitle",
  "cardVideo": "jLYcwq_cardVideo",
  "cardsContainer": "jLYcwq_cardsContainer",
  "section": "jLYcwq_section",
  "textContainer": "jLYcwq_textContainer",
});
